import { render, staticRenderFns } from "./ComCdPopup.vue?vue&type=template&id=06457018&"
import script from "./ComCdPopup.vue?vue&type=script&lang=js&"
export * from "./ComCdPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports